import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../../../../common/state';
import { ERepair } from '../../../../../../../json_query';
import { setRepair } from '../../../../../../state/advanced/repair';

import { Repair as RepairComponent } from './repair';

export const Repair = connect(
  (state: IAppState) => ({
    repairs: (state.filters.jsonQuery.repair && state.filters.jsonQuery.repair.value) || [],
  }),
  (dispatch: Dispatch) => ({
    onChange: (value: ERepair[]) => {
      dispatch(setRepair(value));
    },
  }),
)(RepairComponent);
